<template>
  <div>
    <b-card-body>
      <b-card class="loadContainer">
        <b-form submit.stop.prevent="loadSelectedScenario">
          <!-- <p><b>Simulador - Configuração de comunicação</b></p>
          <BR /> -->
          <b-row v-if="loaded">
            <b-col sm="12">
              <div class="tableTxt">
                <div>
                  <span class=""><b>{{$t('loadScenarioFilter')}}</b></span>
                  <b-input class="mt-1 input-pentagro" :placeholder="$t('placeholderLoadScenarioFilter')" v-model="filter" />
                </div>
                <!-- <b-button @click="checkSaveXML">Salvar</b-button> -->
              </div>
              <br />
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="12">
              <div v-if="this.scenarioList.length == 0">
                {{$t('scenarioListMessage')}}<br />
              </div>
              <div v-else>
                <div class="row">
                  <!-- <p class="h6">Selecione um cenário:</p> -->
                  <div
                    class="
                      col-12
                      table-responsive-md table-wrapper-scroll-y
                      my-custom-scrollbar
                    "
                  >
                    <!-- <table class="table table-hover table-striped"> -->
                    <table class="table table-hover table-sm">
                      <thead class="thead-dark">
                        <th scope="col">{{$t('savedScenariosHeader')}}</th>
                      </thead>
                      <!-- <tbody class="tableScenarios"> -->
                      <tbody class="">
                        <template>
                          <tr
                            v-for="scenario in this.filteredScenario"
                            :key="scenario.id"
                          >
                            <td
                              :id="'scenario-'+scenario.id" 
                              @click="selectedScenario(scenario.name, scenario.id)"
                              class="text-truncate tableTxt"
                              style="max-width: 100px"
                            >
                              {{ scenario.name }}
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div v-if="loaded" class="rowDistance">
                <div class="text-truncate tableTxt" style="max-width: 370px">
                  <b>{{$t('selectedScenarioLoadScenario')}} </b>{{ this.selection }}
                </div>
                <!-- <b-button @click="loadSelectedScenario()">Carregar</b-button> -->
              </div>
              <b-row v-else class="waitTxt rowDistance"
                >{{$t('waitingaDataBaseLoadScenario')}}</b-row
              >
              <!-- </div> -->
              <br />
            </b-col>
          </b-row>

          <b-row class="groupBtn">
            <div>
              <img
                v-if="!this.scenarioList.length == 0"
                src="@/assets/abrir.png"
                style="margin-left: 30px"
                :title="$t('loadScenarioButtom')"
                alt="Carregar cenário"
                @click="loadSelectedScenario"
              />
              <img
                v-if="!this.scenarioList.length == 0"
                src="@/assets/apagar.png"
                style="margin-left: 30px"
                :title="$t('clear')"
                alt="limpar"
                @click="reset"
              />
              <img
                id="closeModalPassword"
                class="float-right"
                src="@/assets/sair.png"
                style="margin-left: 20px"
                :title="$t('exit')"
                alt="Sair"
                @click="$bvModal.hide('modalLoadScenario')"
              />
            </div>
          </b-row>
        </b-form>
      </b-card>
    </b-card-body>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { urlMainAPI, showError, defaultSuccess } from "@/global";
import { SingletonAreas } from "../flowchart/nodes/_service/singletonAreas";
import GetNameFromXml from "./getNameFromXml"
import axios from "axios";

export default {
  name: "LoadScenario",
  data: function () {
    return {
      selection: "",
      scenarioList: [],
      loaded: false,
      filter: "",
      filteredScenario: [],
    };
  },
  watch: {
    filter() {
      this.filteredScenario = this.scenarioList.filter((scenario) => {
        const scenarioName = scenario.name.toUpperCase();
        const filter = this.filter.toUpperCase();
        if (scenarioName.includes(filter)) return scenario;
      });
    },
  },
  methods: {
    async loadScenariosList() {
      const url = `${urlMainAPI}/getsavedsimulationscenario`;
      await axios
        .get(url)
        .then((res) => {
          // console.log('res', res)
          this.scenarioList = res.data.sort((a, b) =>
            a.name > b.name
              ? 1
              : a.name === b.name
              ? a.id > b.id
                ? 1
                : -1
              : -1
          );
          this.filteredScenario = this.scenarioList;
          this.loaded = true;
        })
        .catch();
    },

    loadSelectedScenario() {
      let obj = {};
      defaultSuccess(this.$t('carregando-cenario'));
      obj.name = this.selection;
      const url = `${urlMainAPI}/loadsimulationscenario`;
      axios.post(url, obj).then((res) => {
        let xml = {};
        xml.name = res.data.name;
        xml.nameXml = GetNameFromXml(JSON.stringify(res.data.scenario))
        xml.scenario = res.data.scenario;
        xml.scenarioResult = res.data.scenarioResult;
        xml.scenarioObjectStructure = res.data.scenarioObjectStructure;

        let oldXml = GetNameFromXml(localStorage.xml)
        let IsDiferent = oldXml != xml.nameXml
        SingletonAreas.LoadScenario(res.data.scenarioObjectStructure, IsDiferent)
        this.$store.commit("setXML", xml);
        localStorage.setItem("xml", JSON.stringify(xml));
        this.$store.commit("setScenarioName", xml.name)
        this.$store.commit('setCanUpdateFormLoss', !SingletonAreas.canLoadFormLoss);
        SingletonAreas.canLoadFormLoss = !SingletonAreas.canLoadFormLoss
        localStorage.setItem("lastScenarioName", xml.name);

        this.selection = "";
        defaultSuccess(this.$t('cenario-carregado'));
        this.$bvModal.hide("modalLoadScenario")
      });
    },

    selectedScenario(name, id){
      this.selection = name
      defaultSuccess(this.$t('cenario') +` ${name} `+ this.$t('selecionado'))
      this.filteredScenario.forEach(s => {
        let el = document.getElementById("scenario-"+s.id)
        if(el)
          el.style.backgroundColor = "#fff"
      })
      let el = document.getElementById("scenario-"+id);
      if(el)
        el.style.backgroundColor = "#8885"
    },
    reset() {
      this.selection = "";
    },
  },
  created() {
    this.loadScenariosList();
  },
};
</script>

<style scoped>
.loadContainer {
  max-width: 600px;
}

.my-custom-scrollbar {
  position: relative;
  height: 200px;
  text-overflow: ellipsis;
  overflow-x: hidden;
}

.table-wrapper-scroll-y {
  display: block;
}

.txtSelection {
  max-width: 400px;
  text-overflow: ellipsis;
}

.my-custom-scrollbar th {
  position: sticky;
  top: 0;
}

.tableTxt {
  font-size: 0.8em;
}

.tableTxt:hover {
  cursor: pointer;
}

.waitTxt {
  display: flex;
  justify-content: center;
  /* font-weight: bold; */
  background: black;
  color: white;
  margin-bottom: 10px;
}

.rowDistance {
  margin-top: 20px;
}

/* td:hover{
  color: white;
  background-color: black;
} */

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
}

img {
  max-height: 35px;
}

table {
  border-collapse: initial;
  border-spacing: initial;
}
</style>
